/**
 * The values were 'avia', 'railways', 'tours' before.
 * Now they are 'av', 'rw', 'tr' because marketing team had problems analyzing traffic.
 * */
export enum FlowType {
  AVIA = 'av',
  RAILWAYS = 'rw',
  TOURS = 'tr',
  B2B = 'b2b',
  HOTELS = 'ht',
}
